export const tableDetailsStyle = {
	wrapper: {
		width: '100%',
		maxWidth: '1074px',
	},
};
